<template>
  <el-dialog :title="title" :visible.sync="visible" width="40%" modal-append-to-body append-to-body close-on-click-modal
    @closed="handleClose">
    <el-form size="small" :model="form" :rules="rules" ref="form" label-width="80px">
      <el-form-item label="指定渠道" prop="channelIds">
        <el-input type="textarea" @focus="channelInputClick(item)" v-model="form.channelIds">
        </el-input>
        <channel-popups :isAppendToBody="true" :modelIsAppendToBody="false" :app-id="form.channels.channelId"
          :visible.sync="channelVisible" @comfirm="channelConfirm($event, item)" :multiple="false"></channel-popups>
      </el-form-item>
      <!-- 	标签 下拉选择 1-白名单 2-灰名单 3-黑名单 -->
      <el-form-item label="标签" prop="label">
        <el-select v-model="form.label" size="small" placeholder="标签" clearable>
          <el-option label="白名单" value="1"></el-option>
        </el-select>
      </el-form-item>
      <!-- 备注 -->
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" show-limit-word v-model="form.remark" maxlength="9999" placeholder="请输入说明"
          clearable></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="hide">取 消</el-button>
      <el-button size="small" type="primary" @click="save" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addChannel, editChannel } from '@/api/security/channelManage';
import ChannelPopups from "@/components/channel-popups";
import Message from '@/components/Message';

export default {
  name: 'WebSaaSAdd',
  inject: ['loadList'],
  components: {
    ChannelPopups
  },
  computed: {
    title() {
      return this.optionType === 'add' ? '新增标签渠道' : '编辑标签渠道';
    },
  },
  data() {
    return {
      /** 渠道选择框 */
      channelVisible: false,
      /** 对话框显隐 */
      visible: false,
      /** 操作类型 */
      optionType: 'add',
      /** 表单 */
      form: {
        channelIds: [],
        /** 渠道 */
        channels: {
          channelId: "",
          channelName: "",
          /** 收发端类型 */
          terminalType: "",
        },
        /** 标签 */
        label: '',
        /** 备注 */
        remark: '',

      },
      /** 表单验证规则 */
      rules: {
        channelIds: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.form.channels) {
                if (this.form.channels.channelId) {
                  callback()
                } else {
                  callback(new Error('请选择渠道'))
                }
              } else {
                callback(new Error('请选择渠道'))
              }
            }, trigger: "blur",
          }
        ],
        label: [
          { required: true, message: '请选择标签', trigger: 'blur' }
        ]
      },
      loading: false,
    };
  },

  methods: {
    /** 保存 */
    save() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          console.log('表单数据:', this.form);
          this.loading = true;
          try {
            if (this.optionType === 'add') {
              this.add()
            } else if (this.optionType === 'edit') {
              this.edit()
            }
          } catch (error) {
            console.error('保存失败:', error);
          } finally {
            this.loading = false;
          }
        }
      });
    },
    /** 编辑 */
    async edit() {
      try {
        this.loading = true;
        const params = { ...this.form }
        delete params.channelIds
        params.channelId = params.channels.channelId
        params.channelName = params.channels.channelName
        params.clientType = params.channels.terminalType
        params.id = params.id
        delete params.channels
        const { data } = await editChannel(params);
        if (data.code === 200) {
          Message.success('编辑成功')
          this.hide()
          this.loadList()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false;
      }
    },
    /** 新增 */
    async add() {
      try {
        this.loading = true;
        const params = { ...this.form }
        delete params.channelIds
        params.channelId = params.channels.channelId
        params.channelName = params.channels.channelName
        params.clientType = params.channels.terminalType
        delete params.channels
        const { data } = await addChannel(params);
        if (data.code === 200) {
          Message.success('新增成功')
          this.hide()
          this.loadList()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false;
      }
    },
    /** 点击渠道选择框 */
    channelInputClick(item) {
      console.log("点击渠道选择框", item);
      this.channelVisible = true;
    },
    /** 确认渠道选择 */
    channelConfirm($event, item) {
      console.log("渠道选择的数据", $event, item);
      const { appId, nameStr, terminalType } = $event;
      this.$set(this.form, 'channels', {
        channelId: appId,
        channelName: nameStr,
        terminalType,
      });
      const idAry = appId.split(",");
      const nameAry = nameStr.split(",");
      const channelIds = idAry.map((item, index) => {
        return `[${item}] ${nameAry[index]}`;
      });
      this.$set(this.form, 'channelIds', channelIds)
    },
    //^ ^--------------对话框自身的方法-------------^ ^
    show(row, optionType) {
      this.optionType = optionType || 'add';
      if (row) {
        console.log("🚀 ~ show ~ row:", row)
        this.form.channelIds = `[${row.channelId}] ${row.channelName}`;
        this.form.channels = {
          channelId: row.channelId,
          channelName: row.channelName,
          terminalType: row.clientType,
        }
        this.form.id = row.id
        this.form.label = String(row.label)
        this.form.remark = row.remark

      }
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    handleClose() {
      this.$set(this, 'form', {
        channels: {
          channelId: "",
          channelName: "",
          terminalType: "",
        },
        label: '',
        remark: '',
      })
      this.$refs.form.clearValidate()
    }
  },
};
</script>

<style lang="scss" scoped></style>
